import { useContext } from 'react';

import { NonProjectDalContext } from '@/contexts/nonProjectDalContext';

export const useNonProjectDal = () => {
  const context = useContext(NonProjectDalContext);

  if (!context) {
    throw new Error(
      'useNonProjectDal must be used within a NonProjectDalProvider'
    );
  }

  return context;
};
